import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PaServiceV2 } from 'src/app/core/models';
import { getTimeForUnits } from 'src/app/utils/time-functions';

@Component({
    selector: 'app-units-display',
    templateUrl: './units-display.component.html',
    styleUrls: ['./units-display.component.scss']
})
export class UnitsDisplayComponent implements OnChanges {
    @Input() service: PaServiceV2 | null = null;
    @Input() newUnits?: number;

    timeUnitsText: string = '';

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['service'] && this.service) {
            this.timeUnitsText = `${getTimeForUnits(this.service.spent_units)} / ${getTimeForUnits(this.service.n_units)}`;
        }
    }

    get usedUnitsPercentage(): number {
        if (!this.service) return 0;
        return (this.service.spent_units / this.service.n_units) * 100;
    }

    get projectedUnitsPercentage(): number {
        if (!this.service || !this.newUnits) return 0;
        const totalProjected = this.service.spent_units + this.newUnits;
        const projectedPercentage = (totalProjected / this.service.n_units) * 100;
        return projectedPercentage - this.usedUnitsPercentage;
    }

    get isExceedingLimit(): boolean {
        if (!this.service || !this.newUnits) return false;
        return this.newUnits > (this.service.available_units ?? 0);
    }
}